import { MessageDescriptor, useIntl } from 'react-intl';

import { TicketTypeFilters, BookingStatusFilters } from '../../types';

import messages from './messages';

interface Args {
  appliedFilters: Set<TicketTypeFilters | BookingStatusFilters>;
  defaultMessage: MessageDescriptor;
}

export const filterMenuSelectionLabel = ({ appliedFilters, defaultMessage }: Args) => {
  const { formatMessage } = useIntl();

  if (appliedFilters.size === 0) {
    return formatMessage(defaultMessage);
  }

  return Array.from(appliedFilters)
    .map((filter) => formatMessage(messages[filter]))
    .join(', ');
};
